import { ReactNode } from 'react'
import { ButtonProps, ModalPresetConfirm, ModalProps } from '@dashboard/ui'
import { useTranslation } from 'react-i18next'

interface ModalConfirmProps extends ModalProps {
  children?: ReactNode
  message?: ReactNode
  confirmButtonText: ReactNode
  cancelButtonText?: ReactNode
  subMessage?: ReactNode
  onConfirm: () => void
  showClose?: boolean
  color?: ButtonProps['color']
}

export const ModalConfirm = (props: ModalConfirmProps) => {
  const { t } = useTranslation()

  return (
    <ModalPresetConfirm
      {...props}
      title={{
        subtitle: props.subMessage,
        children: props.message || t('confirm.title'),
      }}
      cancel={{
        label: props.cancelButtonText || t('Cancel'),
      }}
      submit={{
        color: props.color || 'danger',
        callback: () => {
          props.onClose?.()
          props.onConfirm()
        },
        label: props.confirmButtonText,
      }}
    >
      {props.children}
    </ModalPresetConfirm>
  )
}
